const PrivacyInfo = () => {
  return (
    <div className="max-width">
      <h3> Website Privacy Policy : </h3>
      <p>
        Rozwon Consultants LLC doing business as Rozwon Health or Rozwon.
        <br></br>
        <strong>Website:</strong>
        (RozwonHealth.com) Clinical Service Consultation and Home Health Care
        Provider.
      </p>
      <p>
        <strong>Disclaimer:</strong>
        We may collect, store, use and/or share (“process”) your information
        when you use our (“Services”), Such as when you visit{" "}
        <a href="https://www.rozwonhealth.com">our website</a>{" "}
        (https://www.rozwonhealth.com)
      </p>
      <p>
        The information provided is for general informational purposes only, is
        not a substitute for professional medical or legal advice, and that any
        reliance on it is at the user's own risk.
      </p>
      <p>
        Users have no rights to modify content, and we do not endorse
        third-party sites and or opinions as detailed below.
        <ul>
          <li>
            <strong> Not medical or legal advice: </strong>
            Our content does not constitute medical or legal advice and that
            users should consult a qualified professional for specific needs.
          </li>
          <li>
            <strong> No guarantee of accuracy: </strong>
            We make efforts to ensure accuracy, but we cannot guarantee that the
            information is always complete, accurate, or up-to-date, and we are
            not liable for any inaccuracies.
          </li>
          <li>
            <strong> Limitation of liability: </strong>
            Rozwon Consultants a limited liability company under the state of
            Massachusetts does not warrant or guarantee as well as under mass
            law any damages, including direct, indirect, or consequential loss,
            that may arise from the use of the website.
          </li>
          <li>
            <strong> User's at own risk: </strong>
            Users access and reliability of any stated information at their own
            risk.
          </li>
          <li>
            <strong> Third-party links: </strong>
            Rozwon Consultants LLC. Is not responsible for the content,
            accuracy, or availability of any third-party websites you link to,
            and that any inclusion of a link to a website does not imply any
            endorsement.
          </li>
          <li>
            <strong> Content modification: </strong>
            users accept that we reserve the right to change or modify the
            website's content and disclaimer at any time without prior notice.
          </li>
          <li>
            <strong> Intellectual property: </strong>
            all content including logo on the site is the property of Rozwon
            Consultants LLC, Rozwon Health or Rozwon directed at
            www.Rozwonhealth.com and or is in use with permission and cannot be
            reproduced without written consent.
          </li>
        </ul>
      </p>
    </div>
  );
};

export default PrivacyInfo;
